export const appConfig = {
    baseAPIURL: process.env.VUE_APP_BaseAPIURL || 'https://api.dev.rcassist.io',
    appURL: process.env.VUE_APP_APPURL ? process.env.VUE_APP_APPURL : 'https://app.dev.rcassist.com.au',
    homeURL: process.env.VUE_APP_HomeURL ? process.env.VUE_APP_HomeURL : 'https://dev.rcassist.com.au',
};

appConfig.APILogin = appConfig.baseAPIURL + '/ir/auth/login';
